export type Application = 'vyoo-admin' | 'vyoo-client';

export const applications = {
  admin: 'vyoo-admin' as Application,
  client: 'vyoo-client' as Application,
  default: 'vyoo-admin' as Application,
};

export const applicationEnv = 'REACT_APP_APPLICATION';
